import { render } from "./DetailEvent.vue?vue&type=template&id=4b007f6e"
import script from "./DetailEvent.vue?vue&type=script&lang=js"
export * from "./DetailEvent.vue?vue&type=script&lang=js"

import "./DetailEvent.vue?vue&type=style&index=0&id=4b007f6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__